module.exports = __webpack_public_path__ + "static/media/Bank (10).1b22b898.svg";